import React from 'react'

const Aside: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <aside>{children}</aside>
)

export default Aside
